/**
 * TODO
 * @class Locale
 * @memberOf farmnet.admin.shop
 * @classdesc
 * TODO
 * @memberOf farmnet.admin.shop
 * TODO params
 * @constructor
 */
LocaleService.$inject = [
  '$log',
  'i18nFilter',
  'Contract'];

export function LocaleService($log, i18nFilter, Contract) {
  'use strict';

  // TODO
  // see https://docs.angularjs.org/guide/i18n

  /*
        TODO should be based on plural categories
        see https://docs.angularjs.org/api/ng/directive/ngPluralize
        see http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html
        support for one and other

        :: German ::
        :: English ::
             category    examples                    rules
             ------------------------------------------------------------------------------------------
             one         1	                        one → n is 1;
             other	     0, 2-999; 1.2, 2.07...     other → everything else

        TODO :: Polish :: is more complicated:
        it has one, few, many and other plural categories:
            category    examples                    rules
            ------------------------------------------------------------------------------------------
            one         1	                        one → n is 1;
            few        	2-4, 22-24, 32-34...        few → n mod 10 in 2..4 and n mod 100 not in 12..14;
            many	    0, 5-21, 25-31, 35-41...    many → n is not 1 and n mod 10 in 0..1
                                                           or n mod 10 in 5..9 or n mod 100 in 12..14;
            other	    1.2, 2.07, 5.94...          other → everything else

        Example (with Google Translate, which might be wrong):
            0 Personen          0 osób          many
            1 Person            1 osoba         one
            2 Personen          2 osoby         few
            4 Personen          4 osoby         few
            5 Personen          5 osób          many
            1.0 Personen        1,0 osób        other (?)
            1.1 Personen        1.1 osoby       other
     */

  /**
   * TODO
   *
   * @param {number} count
   * The count which determines the plural category to use.
   * An error will be thrown if count is not a number.
   * @param {{one: *, other: *}} plural
   * Plural category values with at least the categories 'one' and 'other'
   * as properties.
   * @returns {string}
   * TODO find a better name
   */
  this.pluralizeWithCategories = function (count, plural) {
    //// preconditions
    Contract.requiresArgumentToBeDefined(count, 1, 'count');
    Contract.requiresArgumentToBeNumber(count, 1, 'count');

    Contract.requiresArgumentToBeDefined(plural, 2, 'plural');
    // TODO this depends on the language
    var minimalCategoriesGerman = {one: true, other: true};
    Contract.requiresArgumentToBeObjectLike(
      plural,
      2,
      'plural',
      minimalCategoriesGerman
    );

    // TODO should be more general and depend on the language and its plural categories
    switch (count) {
      case 0:
        return plural.hasOwnProperty('zero') ? plural.zero : plural.other;
      case 1:
        return plural.one;
      default:
        return plural.other;
    }
  };

  /**
   * Returns the correct plural translation.
   * The parameter 'count' will replace '{0}' (with String.format)
   * in the translated plural category.
   * @param {number} count
   * The count which determines the plural category to use.
   * An error will be thrown if count is not a number.
   * @param {string} key
   * Should at least contain the subkeys 'key.one' and 'key.other'.
   *
   * TODO should consider the diffenrece int vs float ("1" vs "1.0" are distinct categories)
   */
  this.pluralize = function (count, key) {
    //// preconditions
    Contract.requiresArgumentToBeDefined(count, 1, 'count');
    Contract.requiresArgumentToBeNumber(count, 1, 'count');

    Contract.requiresArgumentToBeDefined(key, 2, 'key');
    Contract.requiresArgumentToBeString(key, 2, 'key');

    var plural = this.pluralizeWithCategories(count, this.getPlural(key));

    return plural.format(count);
  };

  /**
   *
   * @param {string} key
   * @returns {string}
   * @param {{errorOnMissing: boolean, nullForMissing: boolean}} [options]
   */
  this.get = function (key, options) {
    //// preconditions
    Contract.requiresArgumentToBeString(key, 1, 'key');

    options = options || {errorOnMissing: true, nullForMissing: false};

    // TODO

    //// get from i18nFilter
    var value = i18nFilter(key);

    // no translation found
    if (value === key) {
      if (options.errorOnMissing) {
        $log.error('Translation key not set: ', key);
      }

      if (options.nullForMissing) {
        value = null;
      }
    }

    // TODO ensure value to be string

    return value;
  };

  this.has = function (key) {
    //// preconditions
    Contract.requiresArgumentToBeString(key, 1, 'key');

    //// get from i18nFilter
    var value = i18nFilter(key);

    return value !== key;
  };

  /**
   *
   * @param key
   * @returns {{one: string, other: string}}
   */
  this.getPlural = function (key) {
    // TODO is only valid for simple languages (two pl. cat.)

    var plurals = {
      one: this.get(key + '.one'),
      other: this.get(key + '.other')
    };

    var zeroKey = key + '.zero';
    if (this.has(zeroKey)) {
      plurals.zero = this.get(zeroKey);
    }

    return plurals;
  };

  /**
   * Simply apply parseInt() to the returned
   * translation.
   * @param {string} key
   * @returns {Number}
   */
  this.getInteger = function (key) {
    return parseInt(this.get(key));
  };

  /**
   * Simply apply parseFloat() to the returned
   * translation.
   * @param {string} key
   * @returns {Number}
   */
  this.getFloat = function (key) {
    return parseFloat(this.get(key));
  };

  /**
   * An array must be specified with the following "subkeys" of
   * the given parameter 'key':
   *  'key.count' :  the array length
   *  'key.1' : the first entry in the array
   *  'key.2' : the second entry in the array
   *  ...
   *  'key.X' : up to X = count, the array length
   * @param {string} key
   * @return {Array.<string>}
   */
  this.getArray = function (key) {
    // TODO do some checks
    var count = this.getInteger(key + '.count');
    var array = [];

    for (var i = 1; i <= count; i++) {
      array.push(this.get(key + '.' + i));
    }

    return array;
  };
}

